// fuels/my-model
import {
  postData,
  postFormData,
  createFormData,
} from 'src/services/RestApi';

export const apiCreate = async (values) => {
  const { formData, queryData } = requestParams(values);
  return await postFormData('api/fuel/create', formData, queryData);
};

export const apiUpdate = async (values) => {
  const { formData, queryData } = requestParams(values, true);

  return await postFormData('api/fuel/update', formData, queryData);
};

export const apiRemove = async (values) => {
  return await postData('api/fuel/remove', { fuelId: values.id });
};

export const apiBillNo = async (values) => {
  return await postData('api/fuel/bill-no', { fuelId: values.fuelId, billNo: values.billNo });
};

function requestParams(values, isUpdate = false) {
  const formData = createFormData(values);
  const queryData = {};
  if (isUpdate) {
    queryData.fuelId = values.id;
    // PS: myCarId using as prefix for image name
    queryData.myCarId = values.myCarId || values.id;
  }

  if (values.quantity) {
    queryData.quantity = values.quantity;
  }
  if (values.created) {
    // queryData.paidDate = Math.floor(new Date(values.created).getTime() / 1000);
    queryData.paidDate = values.created;
  }
  if (values.plateField?.value) {
    queryData.carId = values.plateField.value;
  }
  if (values.note) {
    queryData.note = values.note;
  }
  if(values.partnerField?.value){
    queryData.partnerId = values.partnerField.value;
  }
  if(values.pricingField?.value){
    queryData.price = values.pricingField.value;
  }
  if(values.cardField){
    queryData.card = values.cardField;
  }

  return { formData, queryData };
}
